import { IconButton, Tooltip } from '@mui/material';
import { SyntheticEvent, useState } from 'react';
import { AddFeedbackToCollectionMenu } from '../AddFeedbackToCollectionMenu';
import { AddToCollectionIcon } from '../AddToCollectionIcon';

interface AddToCollectionIconButtonProps {
  feedbackID: string;
  iconColor?: string;
}

export const AddToCollectionIconButton = ({
  feedbackID,
  iconColor,
}: AddToCollectionIconButtonProps) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLButtonElement>(null);
  const open = Boolean(anchorEl);

  const onMenuOpen = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.stopPropagation();
    event.preventDefault();
    setAnchorEl(event.currentTarget);
  };
  const onMenuClose = (event: SyntheticEvent) => {
    event.stopPropagation();
    setAnchorEl(null);
  };

  return (
    <>
      <Tooltip arrow title="Add to Collection" disableInteractive>
        <IconButton
          id="add-to-collection-button"
          aria-controls={open ? 'save-to-collection-menu' : undefined}
          aria-haspopup="true"
          aria-expanded={open ? 'true' : undefined}
          onClick={onMenuOpen}
          size="small"
        >
          <AddToCollectionIcon sx={{ color: iconColor }} />
        </IconButton>
      </Tooltip>
      {open && (
        <AddFeedbackToCollectionMenu
          anchorEl={anchorEl}
          open={open}
          onClose={onMenuClose}
          feedbackID={feedbackID}
        />
      )}
    </>
  );
};
